export default '/';



// WEBPACK FOOTER //
// ./server/routes/base-url.es6